@if (currentUser()) {
  <div class="profile-card">
    <h2>{{ 'features.profile.title' | translate }}</h2>

    <div class="profile-card__row">
      <div class="profile-card__text">
        <h5>{{ 'features.profile.fields.email' | translate }}</h5>
        <span>{{ currentUser()?.email }}</span>
      </div>
      <div>
        <h5>{{ 'features.profile.fields.fullName' | translate }}</h5>
        <span>{{ currentUser()?.name }}</span>
      </div>
    </div>

    <div class="profile-card__row">
      <div>
        <h5>{{ 'features.profile.fields.nickname' | translate }}</h5>
        <span>{{ currentUser()?.username }}</span>
      </div>
      <div>
        <h5>{{ 'features.profile.fields.birthdate' | translate }}</h5>
        <span>{{ currentUser()?.birthdate | date: 'dd-MM-yyyy' }}</span>
      </div>

      <div>
        <h5>{{ 'features.profile.fields.selectedLanguage' | translate }}</h5>
        <span>{{ getLanguage() | translate }}</span>
      </div>

      @if (getUserStatus() === 'CONFIRMED') {
        <div>
          <h5>{{ 'features.profile.fields.badgeNumber' | translate }}</h5>
          <span>{{ getBadgeNumber() }}</span>
        </div>
      }
    </div>

    @if (getUserStatus() === 'ACCEPTED' || getUserStatus() === 'CONFIRMED' || getUserStatus() === 'PENDING') {
      <div class="profile-card__row">
        <div>
          <h5>{{ 'features.profile.fields.haveFursuit' | translate }}</h5>
          <span>{{ 'features.profile.fields.hasFursuit.' + getFursuitAnswer() | translate }}</span>
        </div>
        <div></div>
      </div>
    }

    @if (getUserStatus() === 'ACCEPTED' || getUserStatus() === 'CONFIRMED' || getUserStatus() === 'PENDING') {
      <div class="profile-card__separator"></div>
      <div class="profile-card__row">
        <div>
          <h5>{{ 'features.profile.registrationStatus.title' | translate }}</h5>
          <span [class]="getStatusClass()">{{ getStatusText() | translate }}</span>
        </div>

        @if (getUserStatus() === 'PENDING') {
          <div>
            <span class="profile-card__row-justify">{{ 'features.profile.registrationStatus.pendingText' | translate }}</span>
          </div>
        }

        @if (getUserStatus() === 'ACCEPTED') {
          <div>
            <h5>{{ ('features.profile.registrationStatus.linkAccess' | translate) + ' ' }}</h5>
            <button class="main-button" (click)="goToLink()">{{ 'features.home.preegistrationButton' | translate }}</button>
            <span>{{ 'features.profile.registrationStatus.reminder' | translate }}</span>
          </div>

          <div></div>
        }

        @if (getUserStatus() === 'CONFIRMED') {
          <div>
            <h5>{{ ('features.profile.fields.iberiaDiscount' | translate) + ':' }}</h5>
            <span>{{ getIberiaDiscount() }}</span>
          </div>

          <div>
            <span>{{ 'features.profile.registrationStatus.confirmedText' | translate }}</span>
          </div>
        }

        @if (getUserStatus() === 'ACCEPTED' || getUserStatus() === 'CONFIRMED') {
          <div>
            <h5>{{ ('features.profile.registrationStatus.hotelAccess' | translate) + ' ' }}</h5>
            <button class="main-button" (click)="goToLinkHotel()">
              {{ 'features.profile.registrationStatus.hotelButton' | translate }}
            </button>
            <span [innerHTML]="'features.profile.registrationStatus.hotelReminder' | translate"></span>
          </div>
        }
      </div>
    }

    @if (getUserStatus() === 'ACCEPTED' || getUserStatus() === 'CONFIRMED' || getUserStatus() === 'PENDING') {
      <div class="profile-card__separator"></div>
      <div class="profile-card__row">
        <div>
          <h5>{{ 'features.profile.ticketPurchased.title' | translate }}</h5>
          <span>{{ currentRegistration()?.data?.registrationData?.ticketType }}</span>
        </div>
        @if (currentRegistration()?.data?.registrationData?.ticketType === 'GOLD' || getTshirtAnswerRaw()) {
          <div>
            <h5>{{ 'features.profile.fields.hasTshirt.size' | translate }}</h5>
            <span>{{ getTshirtSize() }}</span>
          </div>

          <div></div>
        }
        <div>
          <h5>{{ 'features.profile.fields.hasTshirt.title' | translate }}</h5>
          <span>{{ 'features.profile.fields.hasTshirt.' + getTshirtAnswer() | translate }}</span>
        </div>
      </div>
    }

    <div class="profile-card__separator"></div>
    <div class="profile-card__image">
      <img src="resources/img/pictures/little-guy-adri.png" alt="" srcset="" />
    </div>
  </div>
}
